import React from 'react';

import { Typography } from '@mui/material';
import { AIReasoningIcon } from 'src/components/icons/AIReasoningIcon';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  reasoningBody: {
    maxHeight: 160,
    overflow: 'auto',
  },
  reasoningHeader: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(0.5),
  },
  reasoningMuted: {
    color: theme.palette.text.secondary,
  },
  reasoningSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
  },
  reasoningText: {
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap',
  },
}));

interface AiReasoningSectionProps {
  reasoning: string | null | undefined;
  className?: string;
}

export function AiReasoningSection({ className, reasoning }: AiReasoningSectionProps) {
  const { classes, cx } = useStyles();

  if (!reasoning) return null;

  return (
    <div className={cx(classes.reasoningSection, className)}>
      <div className={classes.reasoningHeader}>
        <AIReasoningIcon height={14} width={14} />
        <Typography variant="caption">AI Reasoning</Typography>
      </div>
      <div className={classes.reasoningBody}>
        <Typography className={classes.reasoningText} variant="body2">
          {reasoning}
        </Typography>
      </div>
    </div>
  );
}
